import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import BaseEventCard from './BaseEventCard';
import './styles/featured-event-card.less';

const FeaturedEventCard = ({ event }) => {
  const classNames = useClassName('FeaturedEventCard');
  return (
    <BaseEventCard event={event} classNames={classNames} variant="featured" />
  );
};

FeaturedEventCard.propTypes = {
  event: PropTypes.object.isRequired,
};

export default FeaturedEventCard;
